import { FC, useMemo } from 'react';

import { SliderArrow } from 'components/Slider';

import { ScOutsideContainer } from 'components/Slider/styled';

import {
  ScArrowInsidePrev,
  ScArrowInsideNext,
  ScArrowOutsideBox,
  ScArrowOutside,
  ScArrowInsideProps,
} from './styled';

import { ReactComponent as ArrowLeftIcon } from 'assets/images/arrowLeft2.svg';
import { ReactComponent as ArrowRightIcon } from 'assets/images/arrowRight2.svg';
import { useMedia } from 'modules/common/hooks/useMedia';

export type SliderPropsWithArrows =
  | ({
      type: SliderArrow.INSIDE;
      alwaysVisible?: boolean;
    } & Pick<
      ScArrowInsideProps,
      'rightArrowPosition' | 'leftArrowPosition' | 'bgArrowButtons'
    >)
  | {
      type: SliderArrow.OUTSIDE;
      hide?: boolean;
      componentLeft?: React.ReactNode;
      componentRight?: React.ReactNode;
    };

export interface ArrowsProps {
  isBeginning: boolean;
  isEnd: boolean;
  isNewUser?: boolean;
  onPrev: () => void;
  onNext: () => void;
  withArrows?: SliderPropsWithArrows;
}

export const Arrows: FC<ArrowsProps> = ({
  withArrows,
  isBeginning,
  isEnd,
  isNewUser,
  onPrev,
  onNext,
}) => {
  const { isMobile } = useMedia();

  const arrowComp = useMemo(() => {
    switch (withArrows?.type) {
      case SliderArrow.INSIDE:
        return withArrows?.alwaysVisible || !isMobile ? (
          <>
            <ScArrowInsidePrev
              onClick={onPrev}
              position={withArrows.leftArrowPosition}
              isNewUser={isNewUser}
              bgArrowButtons={withArrows.bgArrowButtons}
            >
              <ArrowLeftIcon />
            </ScArrowInsidePrev>
            <ScArrowInsideNext
              onClick={onNext}
              position={withArrows.rightArrowPosition}
              isNewUser={isNewUser}
              bgArrowButtons={withArrows.bgArrowButtons}
            >
              <ArrowRightIcon />
            </ScArrowInsideNext>
          </>
        ) : null;

      case SliderArrow.OUTSIDE:
        return (
          <ScOutsideContainer>
            <div className="left-col">{withArrows.componentLeft}</div>
            <div className="right-col">
              {withArrows.componentRight}

              {!isMobile && !withArrows.hide && (
                <ScArrowOutsideBox>
                  <ScArrowOutside disabled={isBeginning} onClick={onPrev}>
                    <ArrowLeftIcon />
                  </ScArrowOutside>
                  <ScArrowOutside disabled={isEnd} onClick={onNext}>
                    <ArrowRightIcon />
                  </ScArrowOutside>
                </ScArrowOutsideBox>
              )}
            </div>
          </ScOutsideContainer>
        );

      default:
        return null;
    }
  }, [withArrows, isMobile, onPrev, onNext, isBeginning, isEnd, isNewUser]);

  return <>{arrowComp}</>;
};
